// extracted by mini-css-extract-plugin
export default {"container":"o5wkEdtrNXn6cyGd5XEi","disabled":"EGyXKq0qJhQ1N8anxCSi","title":"W4zdFsKwqpffMcLxPgnL","amount":"e9b2XaeUu5RlxvbHrDkx","description":"h5FBM9OgpkT3C2eMu8y5"};